import React from 'react';
import PropTypes from 'prop-types';

const Alert = ({ level = 'info', label = '', children }) => {
  let className;
  switch (level) {
    case 'error':
      className = 'bg-white border-orange-500 text-orange-700';
      break;
    case 'warning':
      className = 'bg-white border-yellow-500 text-yellow-700';
      break;
    case 'info':
    default:
      className = 'bg-white border-blue-500 text-blue-700';
  }

  return (
    <div className={`border-l-4 p-4 ${className}`} role="alert">
      {label && <p className="font-bold">{label}</p>}
      <p>{children}</p>
    </div>
  );
};

Alert.propTypes = {
  children: PropTypes.node.isRequired,
  level: PropTypes.string,
  label: PropTypes.string
};

export default Alert;
